/* eslint-disable import/prefer-default-export */
export const ADMIN_ROLE_NAME = 'admin';
